export const INTERNAL_DOC_CATEGORIES_CARD_ID = 'internalDocCategoriesCard';

export const INTERNAL_DOC_CATEGORIES_PER_PAGE = 20;

export const DEBOUNCE_DELAY = 300;
